"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _SttPaginationActions = _interopRequireDefault(require("./SttPaginationActions"));
var _styles = require("@material-ui/core/styles");
var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    mobile: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center'
    }
  };
});
function SttTablePagination(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    xsDown: true
  }, /*#__PURE__*/_react["default"].createElement(_TablePagination["default"], _extends({}, props, {
    ActionsComponent: _SttPaginationActions["default"]
  }))), /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    smUp: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.mobile
  }, /*#__PURE__*/_react["default"].createElement(_TablePagination["default"], _extends({}, props, {
    ActionsComponent: function ActionsComponent() {
      return null;
    },
    className: classes.row
  })), /*#__PURE__*/_react["default"].createElement(_SttPaginationActions["default"], props))));
}
var _default = SttTablePagination;
exports["default"] = _default;